module.exports = __webpack_public_path__ + "img/mode_main.c3110fec.png";